import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdministrationComponent} from './view-layer/components/administration.component';
import {SourcesComponent} from './view-layer/components/sources.component';
import { LoginComponent } from './view-layer/components/login.component';
import { ContentComponent } from './view-layer/components/content_db.component';
import { LineageComponent } from './view-layer/components/lineage.component';
import { ChangesSourcesComponent } from './view-layer/components/changes-sources.component';
import { GlossaryComponent } from './view-layer/components/glossary.component';

export const routes: Routes = [
  { path: '', component: LoginComponent},
  {path: 'administration', component: AdministrationComponent},
  {path: 'content', component: ContentComponent},
  {path: 'sources', component: SourcesComponent},
  { path: 'auth', component: LoginComponent },
  { path: 'lineage', component: LineageComponent },
  { path: 'change-sources', component: ChangesSourcesComponent },
  { path: 'glossary', component: GlossaryComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
